module.exports = __webpack_public_path__ + "img/img_ticket_center.2ac77118.png";